// extracted by mini-css-extract-plugin
export default {"main":"styles_main__xSQLD","active":"styles_active__XREc4","text":"styles_text__zDm-+","number":"styles_number__5ByFt"};